<template>
  <!-- Buttons -->
  <HorizontalScrollWrapper
    ref="scrollWrapperRef"
    :capture-vertical-scroll
    class="relative flex h-full items-center justify-between"
  >
    <LoadingWrapper compact :loading>
      <p v-if="assets.length === 0" class="text-gray-500 italic">
        Geen zichtbare installaties in dit portfolio
      </p>
      <div v-else class="flex gap-2">
        <BaseButton
          v-for="asset in assets"
          :key="asset.id"
          plain
          small
          :class="{ 'pointer-events-none': !clickable }"
          @click="onAssetClicked(asset)"
        >
          <StatusIndicatorComponent :asset no-tooltip />
          <span class="mx-1">{{ asset.displayName }}</span>
        </BaseButton>
      </div>
      <div
        v-if="showSearch"
        class="sticky right-0 -ml-2 h-full place-content-center bg-linear-to-r from-white/0 via-white via-20% to-white pr-4 pl-8 md:pr-10"
      >
        <BaseButton plain small @click="onSearchClicked">
          <BaseIcon name="search" class="text-lg text-gray-900" />
        </BaseButton>
      </div>
    </LoadingWrapper>
  </HorizontalScrollWrapper>
</template>

<script setup>
import { ref, watch } from "vue"
import { useRoute, useRouter } from "vue-router"
import { triggerEvent } from "@/services/plausibleService.js"
import useNavigationStore, {
  meteringPointSelectionRoute,
} from "@/stores/navigationStore.js"
import useFilterStore from "@/stores/filterStore.js"
import {
  BaseIcon,
  BaseButton,
  LoadingWrapper,
} from "@repowerednl/ui-component-library"
import StatusIndicatorComponent from "@/components/information/StatusIndicatorComponent.vue"
import HorizontalScrollWrapper from "@/components/utilities/HorizontalScrollWrapper.vue"

defineProps({
  /**
   * Array of asset stores to display in the asset bar.
   */
  assets: {
    type: Array,
    required: true,
  },
  /**
   * Whether clicking the assets navigates to their respective pages.
   */
  clickable: Boolean,
  /**
   * Show a loading state for the asset bar.
   */
  loading: Boolean,
  /**
   * Show the search button at the end of the asset bar.
   */
  showSearch: Boolean,
  /**
   * Translate vertical scrolling to horizontal scrolling.
   */
  captureVerticalScroll: Boolean,
})

const route = useRoute()
const router = useRouter()
const navigationStore = useNavigationStore()
const filterStore = useFilterStore()
const scrollWrapperRef = ref()

async function onAssetClicked(asset) {
  await router.push({ name: meteringPointSelectionRoute(route) })
  filterStore.setMeteringPoint(asset)
  triggerEvent("asset-bar:asset-click")
}

function onSearchClicked() {
  navigationStore.openSearch()
  triggerEvent("asset-bar:search-click")
}

// Reset asset bar scroll position when the route changes
watch(
  () => route.name,
  () => {
    if (scrollWrapperRef.value) {
      scrollWrapperRef.value.resetPosition()
    }
  },
)
</script>
